import { resolveAliceSuggestions } from '@command-center/core-platform';
import type {
  AlicePageContext,
  AliceSuggestedAction,
  PortalAliceConfig,
} from './alice.types';

/**
 * Thin adapter over the shared, config-driven resolver in
 * `@command-center/core-platform`. The suggestion catalog now lives in the
 * shared package so every portal (internal / client / sandbox) reuses the same
 * source instead of hard-coding suggestions per page.
 */
export function getAliceSuggestions(
  context: AlicePageContext,
  config: PortalAliceConfig,
): AliceSuggestedAction[] {
  return resolveAliceSuggestions(context, config);
}
